import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TnC(_ref) {
  var _config$deals, _config$deals2;
  var handleTnC = _ref.handleTnC,
    handleOnChange = _ref.handleOnChange,
    termsCheckbox = _ref.termsCheckbox,
    config = _ref.config;
  // text-accent-content
  return /*#__PURE__*/_jsxs("div", {
    className: "mt-5 flex  mb-3 gap-2",
    children: [/*#__PURE__*/_jsx("input", {
      type: "checkbox",
      checked: termsCheckbox,
      onChange: handleOnChange,
      className: "checkbox-sm bg-white rounded-md border-gray-100 checked:bg-blue-600",
      autoComplete: "off"
    }), /*#__PURE__*/_jsxs("p", {
      className: "".concat(config !== null && config !== void 0 && (_config$deals = config.deals) !== null && _config$deals !== void 0 && (_config$deals = _config$deals.dealLayout) !== null && _config$deals !== void 0 && _config$deals.termsAndConditionsClassName ? config === null || config === void 0 || (_config$deals2 = config.deals) === null || _config$deals2 === void 0 || (_config$deals2 = _config$deals2.dealLayout) === null || _config$deals2 === void 0 ? void 0 : _config$deals2.termsAndConditionsClassName : " text-accent-content mx-auto text-sm break-words leading-4"),
      children: ["I agree to the", " ", /*#__PURE__*/_jsx("button", {
        onClick: handleTnC,
        className: "text-primary font-bold text-sm underline ",
        children: "Terms & Conditions"
      })]
    })]
  });
}
export default TnC;